var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFullUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.35156 15.4168C10.0043 14.1123 13.9957 14.1123 17.6484 15.4168C18.4586 15.7061 19 16.4734 19 17.3338V18.6492C19 19.8366 17.948 20.7488 16.7725 20.5808L15.8184 20.4451C13.2856 20.0833 10.7144 20.0833 8.18164 20.4451L7.22754 20.5808C6.05204 20.7488 5 19.8366 5 18.6492V17.3338C5.00004 16.4734 5.54136 15.7061 6.35156 15.4168Z",
    fill: "#181F28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.39919C14.2091 3.39919 16 5.19005 16 7.39919C16 9.60832 14.2091 11.3992 12 11.3992C9.79086 11.3992 8 9.60832 8 7.39919C8 5.19005 9.79086 3.39919 12 3.39919Z",
    fill: "#181F28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullUser);
export default __webpack_public_path__ + "static/media/fullUser.4ed5bb359568f6a762523e5041fefed8.svg";
export { ForwardRef as ReactComponent };